/* -------------------------------------------------------------------------- */
/*                                     Paths                                  */
/* -------------------------------------------------------------------------- */

export const paths = {
	public: {
		catalogMeasurabilityProjects: {
			path: '/catalog-measurabilities',
		},
		catalogMeasurabilityProjectDetails: {
			path: '/catalog-measurabilities/:projectId',
		},
		catalogAdditionalityProjects: {
			path: '/catalog-additionalities',
		},
		catalogAdditionalityProjectDetails: {
			path: '/catalog-additionalities/:projectId',
		},
		cgu: {
			path: '/cgu',
		},
		cguFr: {
			path: '/cgu/fr',
		},
		cguEn: {
			path: '/cgu/en',
		},
	},
	auth: {
		login: {
			path: '/login',
		},
		loginArec1: {
			path: '/arec/login',
		},
		loginArec2: {
			path: '/arec',
		},

		loginArec: {
			path: '/arec/login',
		},
		signIn: {
			path: '/auth/sign_in',
		},
		updatePassword: {
			path: '/auth/update_password',
		},
		updatePasswordArec: {
			path: '/auth/arec/update_password',
		},
		updateEmail: {
			path: '/auth/update_email',
		},
	},
	app: {
		root: {
			path: '/',
			title: 'Dashboard',
		},
		dashboard: {
			path: '/',
			title: 'Dashboard',
		},
		accountSettings: {
			path: '/account-settings',
		},
		productions: {
			path: 'productions',
		},
		mintHistory: {
			path: 'productions/mint-history',
		},
		importHistory: {
			path: 'productions/import-history',
		},
		measurabilities: {
			path: 'measurabilities',
		},
		additionalities: {
			path: 'additionalities',
		},
		offsets: {
			path: 'offsets',
			title: 'sidebar.offsets',
		},
		sites: {
			path: 'sites',
		},
		apiTokens: {
			path: 'api-tokens',
		},
		meterPoints: {
			path: 'meter-points',
		},
		producers: {
			path: 'producers',
		},
		brands: {
			path: 'brands',
		},
		users: {
			path: 'users',
		},
		organizations: {
			path: 'organizations',
		},
		conversionFactors: {
			path: 'conversion-factors',
		},
		measurabilityProjects: {
			path: 'measurability-projects',
		},
		measurabilityProjectDetails: {
			path: 'measurability-projects/:projectId',
		},
		additionalityProjects: {
			path: 'additionality-projects',
		},
		additionalityProjectDetails: {
			path: 'additionality-projects/:projectId',
		},
	},
	error: {
		path: '*',
	},
} as const;
